module.exports = require('./helpers/bundle-url').getBundleURL('kwCuI') + "annotation-result-passed-icon.3dc0e2a9.svg";